import { Box, Flex, HStack, Image, Text, VStack } from '@chakra-ui/react'
import { FaCheckCircle } from 'react-icons/fa'
import { PropInvalida } from '../../../../../../Utils/Helper'
import { GraficoSelf } from '../../../../si/components/GraficoPI/GraficoSelf'
import { IperfilDto2 } from '../../../../si/send'
interface ICardColaboradorProps{
  perfil: IperfilDto2
  par?: boolean
  selecionado?: boolean
  onSelect: (id: string) => void
  compacto?: boolean

}
export const CardColaboradorSi: React.FC<ICardColaboradorProps> = ({ onSelect, selecionado, par, perfil, compacto }: ICardColaboradorProps) => {
  const pequeno = PropInvalida(compacto) ? false : compacto
  return (
    <Box border='1px' borderColor='var(--c4)'
    height={pequeno ? '3rem' : '100%'}
     my={0} bgColor={((par === undefined) || !par) ? 'var(--AzulOpacoBg)' : 'white'}
     px={'1rem'} py={pequeno ? '.1rem' : '.35rem'} alignContent='center' borderRadius='.25rem' width={'100%'} onClick={() => onSelect(perfil.assessmentId ?? '')} cursor={'pointer'} _hover={{ bg: 'var(--RosaOpacoBg)', borderColor: 'var(--Rosa)' }}>
       <Flex wrap='wrap' gap={'1rem'} justifyContent='space-between' alignItems='center'

       height={'100%'}>
        <Flex flex={1} gap={'1rem'}>
          <Flex alignItems={'center'} fontSize={'20px'}>
            {selecionado ? <FaCheckCircle color='var(--Green2)'/> : <FaCheckCircle color='var(--c6)'/>}
          </Flex>
          <Box cursor={'pointer'} alignItems='center'>
            <Flex justifyContent='center' gap={'.25rem'} flexDir='column'>
              <Text fontSize={pequeno ? '12px' : '14px'} lineHeight={pequeno ? '12px' : '14px'} fontWeight={600}>{perfil.nome}</Text>
              <Text fontSize={pequeno ? '12px' : '14px'} lineHeight={pequeno ? '12px' : '14px'} fontWeight={400} color={'var(--Gray2)'}>{perfil.email}</Text>
            </Flex>
          </Box>
        </Flex>
        <Flex alignItems={'center'} gap={'.325rem'} fontSize={pequeno ? '12px' : '14px'}>
          Data de conclusão: <strong>{perfil.dataConclusao}</strong>
        </Flex>
        <VStack width='10rem' spacing={pequeno ? '0.005rem' : '0.1rem'}>
          <Image src={perfil.selo.urlAvatar} fit='scale-down' width='2rem' maxH={pequeno ? '25px' : '2rem'}/>
          <Text fontSize={pequeno ? '8px' : '10px'} fontWeight={'bold'}> {perfil.selo.nome ?? ''}</Text>
        </VStack>
        <HStack width={pequeno ? '10rem' : '15rem'} display={'flex'} maxH={pequeno ? '35px' : '80px'} overflowY={'hidden'} alignItems={'center'} gap={'.5rem'}>
          <GraficoSelf fatorA={perfil.self.aSigma} fatorB={perfil.self.bSigma} fatorC={perfil.self.cSigma} fatorD={perfil.self.dSigma}/>
          {/* <Flex minW={'2rem'}><Text fontSize='xs'>: {perfil.pi ?? ''}</Text></Flex> */}
        </HStack>
      </Flex>
    </Box>
  )
}
